export default __webpack_public_path__ + "static/media/angbao-bonus-raya.11fe18c7.webp";